import { render, staticRenderFns } from "./DarBaja.vue?vue&type=template&id=b7ffb2c2&"
import script from "./DarBaja.vue?vue&type=script&lang=js&"
export * from "./DarBaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports